import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getBackendUrl } from '../../utils/api';

const BACKEND_URL = getBackendUrl();
const API = `${BACKEND_URL}/api`;

export const MasterAnalyticsContent = () => {
  const [timeline, setTimeline] = useState([]);
  const [topRestaurants, setTopRestaurants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [days, setDays] = useState(30);

  useEffect(() => {
    fetchAnalytics();
  }, [days]);

  const fetchAnalytics = async () => {
    try {
      setLoading(true);
      const [timelineRes, comparisonRes] = await Promise.all([
        axios.get(`${API}/master/analytics/timeline?days=${days}`),
        axios.get(`${API}/master/analytics/comparison?limit=10`)
      ]);
      
      setTimeline(timelineRes.data.timeline || []);
      setTopRestaurants(comparisonRes.data.top_by_revenue || []);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching analytics:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  // Calculate max values for chart scaling
  const maxRevenue = Math.max(...timeline.map(d => d.revenue), 1);
  const maxOrders = Math.max(...timeline.map(d => d.orders), 1);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-white">Análises e Métricas</h1>
          <p className="text-gray-400 mt-1">Visualize o desempenho do sistema</p>
        </div>
        <select
          value={days}
          onChange={(e) => setDays(Number(e.target.value))}
          className="glass-input"
        >
          <option value={7}>Últimos 7 dias</option>
          <option value={30}>Últimos 30 dias</option>
          <option value={90}>Últimos 90 dias</option>
        </select>
      </div>

      {/* Revenue Timeline Chart */}
      <div className="glass-card">
        <h2 className="text-xl font-semibold text-white mb-4">Evolução da Receita</h2>
        <div className="space-y-2">
          {timeline.map((item, index) => {
            const heightPercent = (item.revenue / maxRevenue) * 100;
            return (
              <div key={index} className="flex items-center gap-3">
                <div className="w-24 text-sm text-gray-400">
                  {new Date(item.date).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })}
                </div>
                <div className="flex-1">
                  <div className="relative h-8 bg-gray-800 rounded-lg overflow-hidden">
                    <div
                      className="absolute inset-y-0 left-0 bg-gradient-to-r from-green-500 to-emerald-500 transition-all duration-300"
                      style={{ width: `${heightPercent}%` }}
                    />
                    <span className="absolute inset-0 flex items-center px-3 text-sm font-medium text-white">
                      R$ {item.revenue.toFixed(2)}
                    </span>
                  </div>
                </div>
                <div className="w-20 text-sm text-gray-400 text-right">
                  {item.orders} pedidos
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Top Restaurants */}
      <div className="glass-card">
        <h2 className="text-xl font-semibold text-white mb-4">Top 10 Lojas por Receita</h2>
        <div className="space-y-3">
          {topRestaurants.map((restaurant, index) => (
            <div key={restaurant.id} className="flex items-center gap-4 p-3 bg-gray-800/50 rounded-lg">
              <div className="flex items-center justify-center w-10 h-10 rounded-full bg-gradient-to-r from-yellow-500 to-orange-500 font-bold text-white">
                {index + 1}
              </div>
              <div className="flex-1">
                <p className="text-white font-medium">{restaurant.name}</p>
                <p className="text-sm text-gray-400">
                  {restaurant.orders} pedidos • Ticket médio: R$ {restaurant.avg_order_value.toFixed(2)}
                </p>
              </div>
              <div className="text-right">
                <p className="text-green-400 font-bold text-lg">R$ {restaurant.revenue.toFixed(2)}</p>
                <p className="text-xs text-gray-500">{restaurant.orders_last_7_days} pedidos (7 dias)</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};


// ============================================================================
// MASTER REPORTS CONTENT (Relatórios Financeiros)
// ============================================================================

